import { useCallback } from 'react';
import { PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY } from '../ui/constants';
import { CollectionUI } from '../ui/users/types';
import { useExperimentFlag } from './useExperimentFlag';

export const useIsCollectionPromoteInFeed = (collection: CollectionUI) => {
    const isEnabled = String(useExperimentFlag('show_in_feed_onboarding_enabled')) === '1';

    if (!collection.promoteShowInFeedAvailable || !isEnabled) {
        return false;
    }

    const showedCollections = JSON.parse(
        localStorage.getItem(PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY) || '[]',
    );

    return !showedCollections.includes(collection.id);
};

export const useOnCollectionOpen = () => {
    const isEnabled = String(useExperimentFlag('show_in_feed_onboarding_enabled')) === '1';

    if (!isEnabled) {
        return;
    }

    const onCollectionOpen = useCallback((collection?: CollectionUI) => {
        if (!collection) {
            return;
        }
        const showedCollections = JSON.parse(
            localStorage.getItem(PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY) || '[]',
        );

        if (showedCollections.includes(collection.id)) {
            return;
        }

        const updated = showedCollections.concat(collection.id);

        localStorage.setItem(PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY, JSON.stringify(updated));
    }, []);

    return onCollectionOpen;
};
